import React, { Component } from "react";
import "./updateRequestModal.css";
import {
  updateOrderApiRedux,
  uploadTransactionRedux,
} from "../../actions/index";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  getSingleOrderApi,
  getSingleUser,
} from "../../firebase/firebase.utils";
import { sendNotifications } from "../../firebase/fcmRestApi";
import { notifyWarning } from "../../utils/notify";
class UpdateRequestModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderTotal: "",
      localShipping: "",
      orderStatus: "",
      orderNumber: "",
      trackingNo: "",
      purchaseLink: "",
      purchasingSupplier: "",
      purchasingSupplierPayment: "",
      purchasingSupplierQr: "",
      purchasingRmb: "",
      exchangeRate: "",
      warehouse: "",
      shippingMark: "",
      cargoCompany: "",
      lotNo: "",
      ctnNo: "",
      receivedWeight: 0,
      cargoRate: "",
      customerRate: 0,
      refund: 0,
      discount: 0,
      otherCost: 0,
      shippingChargeCargo: "",
      shippingChargeCustomer: "",
      refundNote: "",
      abroadWarehouseAddress: "",
      bangladeshWarehouseAddress: "",
      deliveredBy: "",
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const { order } = nextProps;
    if (order) {
      this.setState({
        orderTotal: order.orderTotal || "",
        note: order.note || "",
        localShipping: order.localShipping || "",
        orderStatus: order.orderStatus || "",
        orderNumber: order.orderNumber || "",
        trackingNo: order.trackingNo || "",
        purchaseLink: order.purchaseLink || "",
        purchasingSupplier: order.purchasingSupplier || "",
        purchasingSupplierPayment: order.purchasingSupplierPayment || "",
        purchasingSupplierQr: order.purchasingSupplierQr || "",
        purchasingRmb: order.purchasingRmb || "",
        exchangeRate: order.exchangeRate || "",
        warehouse: order.warehouse || "",
        shippingMark: order.shippingMark || "",
        cargoCompany: order.cargoCompany || "",
        lotNo: order.lotNo || "",
        ctnNo: order.ctnNo || "",
        receivedWeight: order.receivedWeight || 0,
        cargoRate: order.cargoRate || "",
        customerRate: order.customerRate || 0,
        refund: order.refund || 0,
        discount: order.discount || 0,
        otherCost: order.otherCost || 0,
        shippingChargeCargo: order.shippingChargeCargo || "",
        shippingChargeCustomer: order.shippingChargeCustomer || "",
        refundNote: order.refundNote || "",
        abroadWarehouseAddress: order.abroadWarehouseAddress || "",
        bangladeshWarehouseAddress: order.bangladeshWarehouseAddress || "",
        deliveredBy: order.deliveredBy || "",
      });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { order, ordersApi } = this.props;
    if (!order.purchasingRmb && this.state.purchasingRmb == "") {
      notifyWarning("You must enter purchasing rmb");
      return;
    }
    console.log(order);
    let date = new Date();
    let shipmentStatusScore = 1;
    if (this.state.orderStatus == "Purchased") {
      shipmentStatusScore = 2;
    } else if (this.state.orderStatus == "Received in Warehouse") {
      shipmentStatusScore = 3;
    } else if (this.state.orderStatus == "Ready for fly") {
      shipmentStatusScore = 4;
    } else if (this.state.orderStatus == "Bangladesh customs") {
      shipmentStatusScore = 5;
    } else if (this.state.orderStatus == "Bangladesh warehouse") {
      shipmentStatusScore = 5;
    } else if (this.state.orderStatus == "Zapai warehouse") {
      shipmentStatusScore = 6;
    } else if (this.state.orderStatus == "Delivered") {
      shipmentStatusScore = 7;
    }
    await this.props.updateOrderApiRedux({
      ...order,
      ...this.state,
      shippingChargeCustomer:
        this.state.receivedWeight * this.state.customerRate,
      orderStatus: this.state.orderStatus || order.orderStatus,
      [`${this.state.orderStatus}Date`]: order[`${this.state.orderStatus}Date`]
        ? order[`${this.state.orderStatus}Date`]
        : date.toLocaleDateString("en-GB"),
      [`${this.state.orderStatus}Time`]: order[`${this.state.orderStatus}Time`]
        ? order[`${this.state.orderStatus}Time`]
        : date.toLocaleTimeString("en-GB"),
      shipmentStatusScore,
    });

    console.log(order);
    const newOrder = await getSingleOrderApi(order.orderId);
    console.log(order, newOrder);
    const msg = this.createNotification(order, newOrder);
    console.log(msg);
    const user = await getSingleUser(order.userId);
    console.log(user);
    const message = {
      title: msg.title,
      body: msg.body,
    };
    if (user.deviceToken && user.deviceToken.length > 0) {
      user.deviceToken.map((token) => {
        console.log(token);
        sendNotifications(token, message);
      });
    }

    toast.success("successfully updated Order");
    this.setState({
      orderTotal: "",
      localShipping: "",
      orderStatus: "",
      orderNumber: "",
      trackingNo: "",
      purchaseLink: "",
      purchasingSupplier: "",
      purchasingSupplierPayment: "",
      purchasingSupplierQr: "",
      purchasingRmb: "",
      exchangeRate: "",
      warehouse: "",
      shippingMark: "",
      cargoCompany: "",
      lotNo: "",
      ctnNo: "",
      receivedWeight: 0,
      cargoRate: "",
      customerRate: 0,
      refund: 0,
      discount: 0,
      otherCost: 0,
      shippingChargeCargo: "",
      shippingChargeCustomer: "",
      refundNote: "",
      abroadWarehouseAddress: "",
      bangladeshWarehouseAddress: "",
      deliveredBy: "",
    });
    this.props.startToggleModal(null);
  };

  createNotification = (prevOrder, order) => {
    let msg;
    console.log(prevOrder);
    console.log(order);

    if (!prevOrder.trackingNo && order.trackingNo) {
      msg = {
        title: "Track your order",
        body: `Now You can track orderId:-${order.orderId} with Tracking no:-${order.trackingNo}.`,
      };
      return msg;
    }
    if (!prevOrder.orderNumber && order.orderNumber) {
      msg = {
        title: "Ordered",
        body: `Your orderId:-${order.orderId} has been ordered to the supplier.`,
      };
      return msg;
    }
    if (!prevOrder.localShipping && order.localShipping) {
      msg = {
        title: `orderId:-${order.orderId}`,
        body: `Local shipping charge for this order is ${order.localShipping} Tk.`,
      };
      return msg;
    }
    msg = {
      title: "Order Status",
      body: `Your orderId:-${order.orderId} is ${order.orderStatus}.`,
    };
    return msg;
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  render() {
    const { order, currency } = this.props;

    let totalRmbAmount = 0;
    if (order) {
      order.items.map((item) => {
        item.skus.map((sku) => {
          totalRmbAmount += parseFloat(
            (sku.price * sku.totalQuantity) /
              (order.currency ? order.currency : currency.taka)
          );
        });
      });
    }

    const s = {
      card: {
        background: "#fff",
        borderRadius: 10,
        padding: "14px 16px",
        marginBottom: 12,
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      },
      sectionHead: {
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: 1.4,
        textTransform: "uppercase",
        color: "#18768f",
        borderBottom: "2px solid #e8f4f8",
        paddingBottom: 6,
        marginBottom: 12,
      },
      label: {
        fontSize: 11,
        fontWeight: 600,
        color: "#6b7a8d",
        marginBottom: 3,
        display: "block",
        textTransform: "uppercase",
        letterSpacing: 0.5,
      },
      input: {
        fontSize: 13,
        borderRadius: 6,
        border: "1.5px solid #e0e6ec",
        padding: "7px 10px",
        width: "100%",
        outline: "none",
        background: "#f8fafc",
        color: "#1a2942",
        boxSizing: "border-box",
      },
      grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
      grid3: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 },
    };

    const closeModal = () => {
      this.setState({
        orderTotal: "",
        note: "",
        localShipping: "",
        orderStatus: "",
        orderNumber: "",
        trackingNo: "",
      });
      this.props.startToggleModal(null);
    };

    const computedCustomerCharge = parseInt(
      (this.state.otherCost ? parseInt(this.state.otherCost) : 0) +
        this.state.receivedWeight * this.state.customerRate -
        this.state.refund -
        this.state.discount
    );

    return (
      <>
        <div
          className={
            this.props.toggleModal
              ? "modal fade show"
              : "modal fade show visible-modal"
          }
          id="request_popup"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered request_popup"
            role="document"
            style={{ maxWidth: 700 }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: 14,
                overflow: "hidden",
                border: "none",
                boxShadow: "0 8px 40px rgba(0,37,76,0.22)",
              }}
            >
              {/* ── HEADER ── */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #00254c 0%, #18768f 100%)",
                  padding: "18px 24px 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 10,
                      fontWeight: 700,
                      color: "rgba(255,255,255,0.55)",
                      letterSpacing: 2,
                      textTransform: "uppercase",
                      marginBottom: 4,
                    }}
                  >
                    Update Order
                  </div>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: 18,
                      color: "#fff",
                      letterSpacing: 0.3,
                    }}
                  >
                    #{order && order.orderId}
                  </div>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: 20 }}
                >
                  <div style={{ textAlign: "right" }}>
                    <div
                      style={{
                        fontSize: 10,
                        color: "rgba(255,255,255,0.55)",
                        textTransform: "uppercase",
                        letterSpacing: 1,
                      }}
                    >
                      Total RMB
                    </div>
                    <div
                      style={{
                        fontSize: 17,
                        fontWeight: 700,
                        color: "#fff",
                      }}
                    >
                      ¥{isNaN(totalRmbAmount) ? "-" : parseFloat(totalRmbAmount).toFixed(2)}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={closeModal}
                    style={{
                      background: "rgba(255,255,255,0.15)",
                      border: "none",
                      borderRadius: "50%",
                      width: 32,
                      height: 32,
                      cursor: "pointer",
                      color: "#fff",
                      fontSize: 18,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: 1,
                    }}
                  >
                    ×
                  </button>
                </div>
              </div>

              {/* ── FORM ── */}
              <form onSubmit={this.handleSubmit}>
                <div
                  style={{
                    maxHeight: "68vh",
                    overflowY: "auto",
                    background: "#f4f6f9",
                    padding: "16px 20px",
                  }}
                >
                  {/* STATUS */}
                  <div style={s.card}>
                    <div style={s.sectionHead}>Order Status</div>
                    <select
                      name="orderStatus"
                      onChange={this.handleChange}
                      value={this.state.orderStatus}
                      style={{ ...s.input, cursor: "pointer" }}
                    >
                      <option value="">— Change Status —</option>
                      <option value="Purchased">Purchased</option>
                      <option value="Received in Warehouse">
                        Received in Warehouse
                      </option>
                      <option value="Ready for fly">Ready for Fly</option>
                      <option value="Bangladesh customs">
                        Bangladesh Customs
                      </option>
                      <option value="Bangladesh warehouse">
                        Custom Released
                      </option>
                      <option value="Zapai warehouse">Zapai Warehouse</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Reject">Reject</option>
                    </select>
                  </div>

                  {/* FINANCIALS */}
                  <div style={s.card}>
                    <div style={s.sectionHead}>Financials</div>
                    <div style={s.grid2}>
                      <div>
                        <label style={s.label}>Order Total (Tk)</label>
                        <input
                          type="text"
                          name="orderTotal"
                          style={s.input}
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.orderTotal}
                          required
                        />
                      </div>
                      <div>
                        <label style={s.label}>Local Courier Charge (Tk)</label>
                        <input
                          type="text"
                          name="localShipping"
                          style={s.input}
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.localShipping}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* CHINA ORDER */}
                  <div style={s.card}>
                    <div style={s.sectionHead}>China Order Details</div>
                    <div style={{ ...s.grid2, marginBottom: 12 }}>
                      <div>
                        <label style={s.label}>Order Number</label>
                        <input
                          type="text"
                          name="orderNumber"
                          style={s.input}
                          placeholder="1688 / Taobao order no."
                          onChange={this.handleChange}
                          value={this.state.orderNumber}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Tracking No</label>
                        <input
                          type="text"
                          name="trackingNo"
                          style={s.input}
                          placeholder="China tracking no."
                          onChange={this.handleChange}
                          value={this.state.trackingNo}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Purchase Link</label>
                        <input
                          type="text"
                          name="purchaseLink"
                          style={s.input}
                          placeholder="Product URL"
                          onChange={this.handleChange}
                          value={this.state.purchaseLink}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Purchasing RMB (¥)</label>
                        <input
                          type="number"
                          name="purchasingRmb"
                          style={s.input}
                          placeholder="0.00"
                          onChange={this.handleChange}
                          value={this.state.purchasingRmb}
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label style={s.label}>
                        Today's Exchange Rate (Tk / ¥)
                      </label>
                      <input
                        type="text"
                        name="exchangeRate"
                        style={s.input}
                        placeholder="e.g. 13.50"
                        onChange={this.handleChange}
                        value={this.state.exchangeRate}
                      />
                    </div>
                  </div>

                  {/* SUPPLIER */}
                  <div style={s.card}>
                    <div style={s.sectionHead}>Supplier Info</div>
                    <div style={{ marginBottom: 12 }}>
                      <label style={s.label}>Supplier Name / Info</label>
                      <input
                        type="text"
                        name="purchasingSupplier"
                        style={s.input}
                        placeholder="Supplier details"
                        onChange={this.handleChange}
                        value={this.state.purchasingSupplier}
                      />
                    </div>
                    <div style={s.grid2}>
                      <div>
                        <label style={s.label}>Payment Method</label>
                        <input
                          type="text"
                          name="purchasingSupplierPayment"
                          style={s.input}
                          placeholder="e.g. Alipay"
                          onChange={this.handleChange}
                          value={this.state.purchasingSupplierPayment}
                        />
                      </div>
                      <div>
                        <label style={s.label}>QR Code / Account</label>
                        <input
                          type="text"
                          name="purchasingSupplierQr"
                          style={s.input}
                          placeholder="QR / account no."
                          onChange={this.handleChange}
                          value={this.state.purchasingSupplierQr}
                        />
                      </div>
                    </div>
                  </div>

                  {/* SHIPPING & CARGO */}
                  <div style={s.card}>
                    <div style={s.sectionHead}>Shipping & Cargo</div>
                    <div style={{ ...s.grid2, marginBottom: 12 }}>
                      <div>
                        <label style={s.label}>Shipping Mark</label>
                        <input
                          type="text"
                          name="shippingMark"
                          style={s.input}
                          placeholder="Shipping mark"
                          onChange={this.handleChange}
                          value={this.state.shippingMark}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Cargo Company</label>
                        <input
                          type="text"
                          name="cargoCompany"
                          style={s.input}
                          placeholder="Cargo company"
                          onChange={this.handleChange}
                          value={this.state.cargoCompany}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Lot Number</label>
                        <input
                          type="text"
                          name="lotNo"
                          style={s.input}
                          placeholder="Lot no."
                          onChange={this.handleChange}
                          value={this.state.lotNo}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Carton Number</label>
                        <input
                          type="text"
                          name="ctnNo"
                          style={s.input}
                          placeholder="Carton no."
                          onChange={this.handleChange}
                          value={this.state.ctnNo}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Received Weight (kg)</label>
                        <input
                          type="number"
                          name="receivedWeight"
                          style={s.input}
                          placeholder="0.00"
                          onChange={this.handleChange}
                          value={this.state.receivedWeight}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Cargo Rate (Tk / kg)</label>
                        <input
                          type="text"
                          name="cargoRate"
                          style={s.input}
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.cargoRate}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Customer Rate (Tk / kg)</label>
                        <input
                          type="number"
                          name="customerRate"
                          style={s.input}
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.customerRate}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Total Shipping (Cargo)</label>
                        <input
                          type="text"
                          name="shippingChargeCargo"
                          style={s.input}
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.shippingChargeCargo}
                        />
                      </div>
                    </div>
                    <div style={{ ...s.grid3, marginBottom: 12 }}>
                      <div>
                        <label style={s.label}>Refund (Tk)</label>
                        <input
                          type="number"
                          name="refund"
                          style={s.input}
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.refund}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Discount (Tk)</label>
                        <input
                          type="number"
                          name="discount"
                          style={s.input}
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.discount}
                        />
                      </div>
                      <div>
                        <label style={s.label}>Packaging & Other (Tk)</label>
                        <input
                          type="number"
                          name="otherCost"
                          style={s.input}
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.otherCost}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        background: "#eef6fa",
                        borderRadius: 8,
                        padding: "10px 14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 600,
                          color: "#6b7a8d",
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Total Shipping (Customer)
                      </span>
                      <span
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "#18768f",
                        }}
                      >
                        {isNaN(computedCustomerCharge)
                          ? "-"
                          : computedCustomerCharge}{" "}
                        Tk
                      </span>
                    </div>
                  </div>

                  {/* ADDRESSES & NOTES */}
                  <div style={s.card}>
                    <div style={s.sectionHead}>Addresses & Notes</div>
                    <div style={{ marginBottom: 10 }}>
                      <label style={s.label}>Abroad Warehouse Address</label>
                      <textarea
                        name="abroadWarehouseAddress"
                        rows={2}
                        style={{ ...s.input, resize: "vertical" }}
                        placeholder="Warehouse address (China)"
                        onChange={this.handleChange}
                        value={this.state.abroadWarehouseAddress}
                      />
                    </div>
                    <div style={{ marginBottom: 10 }}>
                      <label style={s.label}>
                        Bangladesh Warehouse Address
                      </label>
                      <textarea
                        name="bangladeshWarehouseAddress"
                        rows={2}
                        style={{ ...s.input, resize: "vertical" }}
                        placeholder="Warehouse address (BD)"
                        onChange={this.handleChange}
                        value={this.state.bangladeshWarehouseAddress}
                      />
                    </div>
                    <div style={{ marginBottom: 10 }}>
                      <label style={s.label}>
                        Delivered Through (include reference)
                      </label>
                      <textarea
                        name="deliveredBy"
                        rows={2}
                        style={{ ...s.input, resize: "vertical" }}
                        placeholder="Delivery details"
                        onChange={this.handleChange}
                        value={this.state.deliveredBy}
                      />
                    </div>
                    <div>
                      <label style={s.label}>Refund Note</label>
                      <textarea
                        name="refundNote"
                        rows={2}
                        style={{ ...s.input, resize: "vertical" }}
                        placeholder="Reason for refund"
                        onChange={this.handleChange}
                        value={this.state.refundNote}
                      />
                    </div>
                  </div>
                </div>

                {/* ── FOOTER ── */}
                <div
                  style={{
                    background: "#fff",
                    borderTop: "1px solid #e8ecf0",
                    padding: "14px 20px",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                  }}
                >
                  <button
                    type="button"
                    onClick={closeModal}
                    style={{
                      padding: "9px 22px",
                      borderRadius: 7,
                      border: "1.5px solid #d0d8e4",
                      background: "#fff",
                      color: "#555",
                      fontWeight: 600,
                      fontSize: 13,
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    style={{
                      padding: "9px 28px",
                      borderRadius: 7,
                      border: "none",
                      background:
                        "linear-gradient(135deg, #00254c 0%, #18768f 100%)",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 13,
                      cursor: "pointer",
                      letterSpacing: 0.5,
                    }}
                  >
                    Update Order
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    singleLotFromRedux: ownProps.singleLot
      ? state.lots.lots.find((lot) => lot.lotNo === ownProps.singleLot.Lot)
      : null,
    ordersApi: state.orders.ordersApi,
    currency: state.users.currency,
  };
};
export default connect(mapStateToProps, {
  updateOrderApiRedux,
  uploadTransactionRedux,
})(UpdateRequestModal);
